<script>
    import { LoginServicio } from "../api/servicios/login.servicio.js";
    import { token } from "../MainStore.js";
    import { navigateTo } from "svelte-router-spa";

    let usuario = "";
    let password = "";

    const loginServicio = new LoginServicio();

    if ($token !== "") {
        navigateTo("/");
    }

    const handleLogin = async () => {
        const respuesta = await loginServicio.Login(usuario, password)

        if (respuesta.token !== "") {
            token.set(respuesta.token);
            navigateTo("/");
        } else {
            // TODO: Error de usuario o contraseña
        }
    };
</script>

<div class="container-fluid h-100 vista-login">
    <div class="row h-100">
        <div class="col-8 col-lg-6 m-auto">
            <div class="row">
                <div class="col-10 text-center mx-auto titulo">
                    <div>Login</div>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col-12">
                    <div class="card mx-auto">
                        <div class="card-body">
                            <form>
                                <div class="form-group">
                                    <label>Usuario</label>
                                    <input class="form-control" placeholder="Usuario" type="text" bind:value={usuario} />
                                </div>
                                <div class="form-group">
                                    <label>Contraseña</label>
                                    <input class="form-control" placeholder="Contraseña" type="password" bind:value={password} />
                                </div>
                            </form>
                            <div class="row">
                                <div class="col-12 text-right">
                                    <button class="btn btn-raised btn-success" on:click={handleLogin}>Enviar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>